module.exports = __webpack_public_path__ + "img/27.3537b652.png";